import { flipCases } from '@/mocks/gossip';

const tileClass = [
  'bg-primary-100/80 text-primary-700',
  'bg-accent-100 text-accent-900',
  'bg-secondary-100 text-secondary-800',
  'bg-primary-50 text-primary-600',
  'bg-accent-50 text-accent-700',
  'bg-secondary-50 text-secondary-700',
];

export default function FlipGallery() {
  return (
    <section id="flip" className="scroll-mt-24 py-10 md:py-14 bg-background-100/70">
      <div className="container-site">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-8 h-1.5 rounded-full bg-primary-500"></span>
            <span className="text-xs font-medium tracking-widest text-foreground-500">FALL FROM GRACE</span>
            <span className="w-8 h-1.5 rounded-full bg-primary-500"></span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">年度<span className="text-primary-600">翻车合集</span></h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto">六大翻车类型一网打尽，每一类都藏着让人"眼前一黑"的名场面。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {flipCases.map((c, i) => (
            <article key={c.id} className="group rounded-2xl border border-background-200 bg-background-50 p-6 hover:-translate-y-1 hover:border-primary-300 transition duration-300">
              <div className={`w-12 h-12 rounded-xl ${tileClass[i % tileClass.length]} flex items-center justify-center mb-4 group-hover:scale-110 transition`}>
                <i className={`${c.icon} text-2xl`}></i>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-lg font-bold text-foreground-950">{c.title}</h3>
                <span className="px-2 py-0.5 rounded-md bg-foreground-950 text-background-50 text-xs">{c.tag}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.summary}</p>
              <div className="mt-4 flex items-center gap-3">
                <span className="flex-1 h-1 rounded-full bg-background-100">
                  <span className="block h-1 rounded-full bg-gradient-to-r from-primary-500 to-accent-400" style={{ width: `${50 + i * 9}%` }}></span>
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">翻车指数 {(50 + i * 9)}%</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}